module.exports = __webpack_public_path__ + "static/img/icons-alarm.7ab81c00.svg";